<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <pre class="json-preview">{{ data.json }}</pre>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'button.close' | translate }}</button>
</mat-dialog-actions>
